import { default_header, default_header_example } from '../defaultData';
import { apiParamDesc } from '../docHelpers';

const getV11APIs = (userInfo) => {
  const isClaimCstm =[178765, 215730, 198896, 216274, 116854, 640].includes(userInfo?.sol_no);
  
  return [
    {
      title: '작업 등록',
      url: '/doc/작업 등록',
      data: [
        {
          version: 'v1.1',
          url: '/work/addWork/v1.1',
          method: 'POST',
          desc: (
            <ul className='style'>
              <li>
                <p>호출한 액션의 작업을 등록합니다.</p>
              </li>
              <li>
                <p>
                  호출가능한 액션은 아래와 같습니다. <br />
                  <br />
                </p>
                <table width='700px'>
                  <tbody>
                    <tr>
                      <th colSpan='2'>주문</th>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>ScrapOrderConfirmList</font>
                      </td>
                      <td>
                        결제완료 주문수집 <br/>
                        <code>작업명: 발주 확인전 주문수집</code>  <br/>
                        <div className='description' style={{ padding: '12px 0' }}>
                          <ul className='style'>
                            <li>발주확인을 지원하지 않는 쇼핑몰은 ScrapOrder 작업으로 자동 등록됩니다.</li>
                            <li>스마트스토어 발주 확인 된 주문 수집 시 결제 완료 주문도 같이 수집되고 있으므로 ScrapOrder 액션으로 호출해 주시기 바랍니다.</li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>ScrapOrder</font>
                      </td>
                      <td>
                        발주확인된 주문 수집 <br/>
                        <code>작업명: 주문수집</code> 
                        <div className='description' style={{ padding: '12px 0' }}>
                          스마트스토어의 경우 해당 액션 호출 시, 결제 완료 주문이 같이 수집됩니다.
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>ScrapOrderAndConfirmDoit</font>
                      </td>
                      <td>
                        결제완료 주문건 모두 발주확인 처리 후 주문수집 <br/>
                        <code>작업명: 발주확인후 주문수집</code> 
                        <div className='description' style={{ padding: '12px 0' }}>
                          <ul className='style'>
                            <li>
                              발주확인을 지원하지 않는 쇼핑몰은 ScrapOrder 작업으로 자동 등록됩니다.
                            </li>
                          </ul>
                        </div>
                        </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>SyncOrderState</font>
                      </td>
                      <td>
                        주문동기화 <br/>
                        <code>작업명: 주문동기화</code> 
                        </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                { userInfo?.aff_no !== 1051 ?
                <>
                  <table width='700px'>
                    <tbody>
                      <tr>
                        <th colSpan='2'>문의</th>
                      </tr>
                      <tr>
                        <td width='200px'>
                          <font color='red'>ScrapCS</font>
                        </td>
                        <td>문의수집</td>
                      </tr>
                      <tr>
                        <td width='200px'>
                          <font color='red'>ScrapEmergencyCS</font>
                        </td>
                        <td>긴급 문의 수집</td>
                      </tr>
                      <tr>
                        <td width='200px'>
                          <font color='red'>ScrapReview</font>
                        </td>
                        <td>상품평 수집</td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <table width='700px'>
                    <tbody>
                      <tr>
                        <th colSpan='2'>정산</th>
                      </tr>
                      <tr>
                        <td width='200px'>
                          <font color='red'>ScrapPayBack</font>
                        </td>
                        <td>정산수집</td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                </> : ''
              }
                <table width='700px'>
                  <tbody>
                    <tr>
                      <th colSpan='2'>상품</th>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>ScrapProd</font>
                      </td>
                      <td>상품수집</td>
                    </tr>
                  </tbody>
                </table>
                <br />
              </li>
              <li>
                <p>쇼핑몰 코드는 쇼핑몰코드 조회 api 를 통하여 확인바랍니다.</p>
              </li>
              <li>
                <p>
                  등록된 작업은 PLAYAUTO 2.0 솔루션에 접속하여 확인가능합니다.
                </p>
              </li>
              <li>
                <p>
                  작업결과는 리턴되는 작업번호(work_no)로 작업결과조회를
                  호출하여 확인가능합니다.
                </p>
              </li>
              <li>
                <p>
                  <code>api_callback_url</code> 등록시 작업결과를 POST 방식으로
                  입력하신 주소로 전송합니다.
                  <br />
                  (전송되는 정보는 작업결과 조회시 조회되는 포멧과 동일합니다.)
                </p>
              </li>
            </ul>
          ),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'act',
              required: 'O',
              type: 'String',
              desc: '작업액션',
            },
            {
              title: 'params',
              required: 'O',
              type: 'Object',
              desc: '',
            },
            {
              title: 'site_code',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 코드',
              indent: 1,
            },
            {
              title: 'site_id',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 아이디',
              indent: 1,
            },
            {
              title: 'std_ol_yn',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '단일상품여부', sub: '온라인상품 작업시 사용됩니다.',
                defaultValue: 'N',
                allowedValues: ['Y', 'N'] }),
              indent: 1,
            },
            {
              title: 'code_scrap_yn',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({ title: '상품 수집 시 특정 상품 수집 여부', sub: '상품수집 작업 시 사용하는 값입니다.',
                allowedValues: [
                  ['true', '특정 상품 가져오기<br />prod_codes(가져올 상품의 쇼핑몰 상품코드)가 필수로 들어가야 합니다.'],
                  ['false', '등록일 기준 모두 가져오기 <br/>prod_scrap_date(수집기간)이 없는경우 1년전 상품까지 수집합니다.']
                ],
                notes: ['값을 넣지않는경우 등록일 기준 전체 수집으로 작업합니다.'] }),
              indent: 1,
            },
            {
              title: 'prod_codes',
              required: '',
              type: 'Array',
              desc: '특정 상품 가져오기 시 가져올 상품의 쇼핑몰 상품코드',
              indent: 1,
            },
            {
              title: 'prod_scrap_date',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '수집기간', sub: '상품 등록일 기준 입력한 값 년전인 상품까지 수집합니다.',
                defaultValue: '1',
                allowedValues: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'] }),
              indent: 1,
            },
            {
              title: 'show_shop_info_yn',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({ title: '등록 작업 쇼핑몰정보 노출여부', sub: '콜백URL 결과 데이터 응답 시 사용됩니다.',
                defaultValue: 'false',
                allowedValues: ['true', 'false'] }),
              indent: 1,
            },
            {
              title: 'api_callback_url',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '작업완료시 작업결과를 수신받을 URL', sub: '해당정보 입력시 작업결과를 입력하신 주소로 POST 방식으로 전송합니다.' }),
            },
          ],
          body_example: {
            act: 'ScrapOrder',
            params: {
              site_code: 'A001',
              site_id: 'test_shop',
            },
            api_callback_url: 'https://test.io/callback',
          },
          response: [
            {
              title: 'work_no',
              required: 'O',
              type: 'Number',
              desc: '등록된 작업번호',
            },
            {
              title: 'message',
              required: 'O',
              type: 'String',
              desc: '결과 메세지',
            },
          ],
          response_example: [
            {
              work_no: 36022757,
              message: '작업이 정상적으로 등록되었습니다.',
            },
            ' --- api_callback_url 설정시 수신 데이터 -----------',
            ...([1051].includes(userInfo.aff_no) ?
              [{
                com: 'PLAYAUTO',
                encver: '2.0',
                encYn: 'N',
                msg: '{"body":{"work_no":172279187,"job_name":"주문수집","status":"완료","message":"[성공] : 변경사항이 없습니다"},"header":{"bizPtrId":"PLAYAUTO","callId":"playauto0001","ifCd":"PLAYAUTO","encType":"UTF-8","token":"PLAYAUTO[13.125.30.102]FTGsfgr5ht4HhfrDbBFW6j==20230010100001"}}'
              }]
              : [{
              work_no: 172279187,
              job_name: '주문수집',
              status: '완료',
              message: ['[성공] : 변경사항이 없습니다'],
            }])
          ],
          error_example: {
            "error_code": "e6xxx",
            "messages": [
              "에러 메세지"
            ]
          }
        },
      ],
    },
    {
      title: '선택작업 등록',
      url: '/doc/선택작업 등록',
      data: [
        {
          version: 'v1.1',
          url: '/work/addWorkSelect/v1.1',
          method: 'POST',
          desc: (
            <ul className='style'>
              <li>
                <p>쇼핑몰에 전송할 상품, 주문, 문의 작업을 등록합니다.</p>
              </li>
              <li>
                <p>
                  호출가능한 액션은 아래와 같습니다. <br />
                </p>
                <table width='700px'>
                  <tbody>
                    <tr>
                      <th colSpan='2'>주문</th>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>SEND_INVOICE</font>
                      </td>
                      <td>
                        운송장전송 <br/>
                        <code>작업명: 송장전송</code>
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>CONFIRM_ORDER</font>
                      </td>
                      <td>
                        주문확인(발주확인) <br/>
                        <code>작업명: 발주확인</code>
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>DELAYED_ORDER_PAYMENT</font>
                      </td>
                      <td>
                        발주확인 전 주문(결제완료주문) 배송지연 <br/>
                        <code>작업명: 배송지연</code>
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>DELAYED_ORDER</font>
                      </td>
                      <td>
                        신규주문 배송지연 <br/>
                        <code>작업명: 배송지연</code>
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>UPDATE_HOPE_DATE</font>
                      </td>
                      <td>희망배송일 변경</td>
                    </tr>
                    {
                      [1, 1957, 5422, 77327, 129725, 121024, 122081, 122082].includes(userInfo?.m_no) || userInfo.aff_no === 1051 ? 
                      <tr>
                        <td width='200px'>
                          <font color='red'>PRINT_SLS_LABEL</font>
                        </td>
                        <td>샤피 SLS 송장발행</td>
                      </tr> : ''
                    }
                  </tbody>
                </table>
                <br />
                <table width='700px'>
                  <tbody>
                    <tr>
                      <th colSpan='2'>쇼핑몰상품</th>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>REGIST_PROD</font>
                      </td>
                      <td>
                        쇼핑몰 등록 전송(판매대기 상태의 상품만 전송가능합니다.)
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>EDIT_PROD_ALL</font>
                      </td>
                      <td>
                        쇼핑몰 수정 전송(수정대기 상태의 상품만 전송가능합니다.)
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>EDIT_PROD</font>
                      </td>
                      <td>
                        쇼핑몰 부분수정 전송(수정대기 상태의 상품만
                        전송가능합니다.)
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>STOP_PROD</font>
                      </td>
                      <td>
                        쇼핑몰 품절 전송(판매중, 수정대기, 종료대기 상태의
                        상품만 전송가능합니다.)
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>RESTORE_PROD</font>
                      </td>
                      <td>
                        쇼핑몰 일시품절복구 전송(일시품절 상태의 상품만
                        전송가능합니다.)
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>REGIST_PROD_RE</font>
                      </td>
                      <td>
                        쇼핑몰 재판매 전송(판매중지 상태의 상품만
                        전송가능합니다.)<br />
                        <code>(쇼핑몰 상품코드 유지)</code>
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>REGIST_PROD_NEW</font>
                      </td>
                      <td>
                        쇼핑몰 재판매 전송(판매중지 상태의 상품만
                        전송가능합니다.)<br />
                        <code>(새상품으로 등록)</code>
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>SYNC_PROD_STATE</font>
                      </td>
                      <td>쇼핑몰상품 동기화</td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>EXTENT_PROD</font>
                      </td>
                      <td>
                        쇼핑몰 판매기간 연장 전송 <br /> (옥션, 지마켓,
                        바이즐, 스마트스토어, 11번가, 카카오 선물하기만 가능)
                      </td>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>CANCEL_PROD</font>
                      </td>
                      <td>쇼핑몰 판매중지 전송</td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <table width='700px'>
                  <tbody>
                    <tr>
                      <th colSpan='2'>문의</th>
                    </tr>
                    <tr>
                      <td width='200px'>
                        <font color='red'>SEND_CS</font>
                      </td>
                      <td>문의답변전송</td>
                    </tr>
                  </tbody>
                </table>
                <br />
                {
                  isClaimCstm ? 
                  <>
                    <table width='700px'>
                      <tbody>
                        <tr>
                          <th colSpan='2'>클레임 주문</th>
                        </tr>
                        <tr>
                          <td width='200px'>
                            <font color='red'>APPROVE_CLAIM</font>
                          </td>
                          <td>클레임 승인</td>
                        </tr>
                        <tr>
                          <td width='200px'>
                            <font color='red'>REJECT_CLAIM</font>
                          </td>
                          <td>클레임 거절</td>
                        </tr>
                        <tr>
                          <td width='200px'>
                            <font color='red'>COLLECT_CLAIM</font>
                          </td>
                          <td>클레임 회수완료</td>
                        </tr>
                        <tr>
                          <td width='200px'>
                            <font color='red'>COMPLETE_CLAIM</font>
                          </td>
                          <td>클레임 완료</td>
                        </tr>
                        <tr>
                          <td width='200px'>
                            <font color='red'>DEFER_CLAIM</font>
                          </td>
                          <td>클레임 보류</td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                  </>
                  : ''
                }
              </li>
              {
                isClaimCstm ? 
                <>
                  <li style={{ marginBottom: "16px" }}>
                    클레임 작업 안내사항
                    <ul style={{ listStyleType: "circle", paddingLeft: "20px", lineHeight: "2" }}>
                      <li>
                        쇼핑몰별·클레임 상태별로 작업 지원 여부가 다르니, 아래 지원 여부를 확인해주시기 바랍니다.
                        <details>
                          <summary>클레임 작업 지원 여부</summary>
                          <table
                            style={{
                              width: "950px",
                              border: "1px solid #ccc",
                              borderCollapse: "collapse",
                              marginBottom: "16px",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th>작업(클레임 유형)</th>
                                <th>지그재그-포스티</th>
                                <th>베네피아</th>
                                <th>카페24</th>
                                <th>토스쇼핑</th>
                              </tr>

                              <tr>
                                <td>클레임 승인<br/><font color="red">APPROVE_CLAIM</font></td>
                                <td>
                                  <code>취소요청, 취소보류</code><br/>
                                  <code>반품요청, 반품보류</code><br/>
                                  <code>교환요청</code>
                                </td>
                                <td>
                                  <br/>
                                  <code>반품요청</code><br/>
                                  <code>교환요청</code>
                                </td>
                                <td>
                                  <code>취소요청</code><br/>
                                  <code>반품요청</code><br/>
                                  <code>교환요청</code>
                                </td>
                                <td>
                                  <code>취소요청</code><br/>
                                  <code>반품요청</code><br/>
                                  <code>교환요청</code>
                                </td>
                              </tr>

                              <tr>
                                <td>클레임 거절<br/><font color="red">REJECT_CLAIM</font></td>
                                <td>
                                  <code>취소요청, 취소보류</code><br/>
                                  <code>반품요청, 반품회수완료, 반품보류</code><br/>
                                  <code>교환요청, 교환회수완료</code>
                                </td>
                                <td>
                                  <br/>
                                  <code>반품요청, 반품진행, 반품보류</code><br/>
                                  <code>교환요청, 교환진행, 교환보류</code>
                                </td>
                                <td>
                                  <code>취소요청</code><br/>
                                  <code>반품요청, 반품진행, 반품회수완료</code><br/>
                                  <code>교환요청, 교환진행, 교환회수완료</code>
                                </td>
                                <td>
                                  <code>취소요청</code><br/>
                                  <code>반품요청, 반품회수완료</code><br/>
                                  <code>교환요청, 교환회수완료</code>
                                </td>
                              </tr>

                              <tr>
                                <td>클레임 회수완료<br/><font color="red">COLLECT_CLAIM</font></td>
                                <td>
                                  <br/>
                                  <code>반품진행</code><br/>
                                  <code>교환진행</code>
                                </td>
                                <td></td>
                                <td>
                                  <br/>
                                  <code>반품진행</code><br/>
                                  <code>교환진행</code>
                                </td>
                                <td>
                                  <br/>
                                  <code>반품진행</code><br/>
                                  <code>교환진행</code>
                                </td>
                              </tr>

                              <tr>
                                <td>클레임 완료<br/><font color="red">COMPLETE_CLAIM</font></td>
                                <td>
                                  <br/>
                                  <code>반품회수완료, 반품보류</code><br/>
                                  <code>교환회수완료</code>
                                </td>
                                <td>
                                  <br/>
                                  <code>반품진행, 반품보류</code><br/>
                                  <code>교환진행, 교환보류</code>
                                </td>
                                <td>
                                  <br/>
                                  <code>반품회수완료</code><br/>
                                  <code>교환회수완료</code>
                                </td>
                                <td>
                                  <br/>
                                  <code>반품회수완료</code><br/>
                                  <code>교환회수완료</code>
                                </td>
                              </tr>

                              <tr>
                                <td>클레임 보류<br/><font color="red">DEFER_CLAIM</font></td>
                                <td>
                                  <code>취소요청</code><br/>
                                  <code>반품요청, 반품회수완료</code><br/>
                                  &nbsp;
                                </td>
                                <td>
                                  <br/>
                                  <code>반품진행</code><br/>
                                  <code>교환진행</code>
                                </td>
                                <td></td>
                                <td></td>
                              </tr>

                            </tbody>
                          </table>
                        </details>
                      </li>
                      <li>작업별·클레임 유형별로 작업 사유 코드가 다르니, 아래 지원 여부를 확인해주시기 바랍니다.
                        <details>
                          <summary>작업 사유 코드</summary>
                          아래 작업별 사유에 해당하는 코드를 파라미터 <code>claim_reason_code</code>에 입력해주시기 바랍니다. (예시: <code>'claim_reason_code': '101'</code>)
                          <table
                            style={{
                              width: "950px",
                              border: "1px solid #ccc",
                              borderCollapse: "collapse",
                              marginBottom: "16px",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th>작업</th>
                                <th>취소<br/><span style={{ color: "red" }}>CANCELLATION</span></th>
                                <th>반품<br/><span style={{ color: "red" }}>RETURN</span></th>
                                <th>교환<br/><span style={{ color: "red" }}>EXCHANGE</span></th>
                              </tr>

                              <tr>
                                <td>클레임 거절<br/><font color="red">REJECT_CLAIM</font></td>

                                <td>
                                  <code>101</code>: 출고 진행중<br/>
                                  <code>102</code>: 발송완료<br/>
                                  <code>103</code>: 고객 요청 철회<br/>
                                  <code>104</code>: 판매 정책상 취소 불가<br/>
                                  <code>ETC</code>: 기타
                                </td>

                                <td>
                                  <code>101</code>: 반품상품이 입고되지 않음<br/>
                                  <code>102</code>: 고객 변심상 철회 대행<br/>
                                  <code>103</code>: 반품불가한 상품<br/>
                                  <code>ETC</code>: 기타
                                </td>

                                <td>
                                  <code>101</code>: 교환상품이 입고되지 않음<br/>
                                  <code>102</code>: 고객 변심상 철회 대행<br/>
                                  <code>103</code>: 교환불가한 상품<br/>
                                  <code>ETC</code>: 기타
                                </td>
                              </tr>

                              <tr>
                                <td>클레임 보류<br/><font color="red">DEFER_CLAIM</font></td>

                                <td>
                                  <code>101</code>: 출고 상태 확인 필요<br/>
                                  <code>102</code>: 구매자와 연락되지 않음<br/>
                                  <code>103</code>: 판매 정책 검토 필요<br/>
                                  <code>ETC</code>: 기타
                                </td>

                                <td>
                                  <code>101</code>: 반품상품이 입고되지 않음<br/>
                                  <code>102</code>: 반품 배송비가 등록되지 않음<br/>
                                  <code>103</code>: 반품 상품이 훼손됨<br/>
                                  <code>104</code>: 구매자와 연락되지 않음<br/>
                                  <code>105</code>: 반품추가금을 요청해야 함<br/>
                                  <code>ETC</code>: 기타
                                </td>

                                <td>
                                  <code>101</code>: 교환상품이 입고되지 않음<br/>
                                  <code>102</code>: 교환 배송비가 등록되지 않음<br/>
                                  <code>103</code>: 교환 상품이 훼손됨<br/>
                                  <code>104</code>: 구매자와 연락되지 않음<br/>
                                  <code>105</code>: 교환추가금을 요청해야 함<br/>
                                  <code>ETC</code>: 기타
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </details>
                      </li>
                      <li>
                        운송장 정보(<code>claim_carr_no</code>, <code>claim_invoice_no</code>)가 필요한 작업은 1건의 주문만 처리 가능합니다.
                        <details>
                          <summary>운송장 정보 필요 클레임 작업</summary>
                          <table
                            style={{
                              width: "700px",
                              border: "1px solid #ccc",
                              borderCollapse: "collapse",
                              marginBottom: "16px",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th>지그재그-포스티</th>
                                <th>베네피아</th>
                                <th>카페24</th>
                                <th>토스쇼핑</th>
                              </tr>

                              <tr>
                                <td>
                                  반품승인(필수 X)<br/>
                                  교환승인(필수 X)
                                </td>
                                <td></td>
                                <td></td>
                                <td>
                                  취소거절<br/>
                                  교환완료
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </details>
                      </li>
                      <li>
                        일부 쇼핑몰의 경우 클레임 작업 시 동일한 주문번호와 주문상태를 가진 주문이 자동으로 함께 처리됩니다. (쇼핑몰: 지그재그-포스티, 베네피아)
                        </li>
                    </ul>
                  </li>
                </> : ''
              }
              <li>
                <p>운송장전송시 출고완료 상태의 주문건만 전송이 가능합니다.</p>
              </li>
              { userInfo?.aff_no !== 1051 ?
              <>
                <li>
                  <p>
                    문의답변 전송시 답변작성완료 상태의 문의만 전송 가능합니다.
                  </p>
                </li>
              </> : ''
              }
              <li>
                <p>
                  500 개 이상의 데이터를 전송하시는경우 500 개단위로 작업이
                  분할되어 등록됩니다.
                </p>
              </li>
              <li>
                <p>
                  <code>api_callback_url</code> 등록시 작업결과를 POST 방식으로
                  입력하신 주소로 전송합니다. <br />
                  - product_info 항목은 상품 작업인 경우에만 출력됩니다.<br />
                  - 전송되는 데이터 포멧은 아래의 예시를 참고해주세요.
                </p>
                <pre className='prettyprint'>
                    ---- 상품작업 결과 (성공시) ----
                    <br />{'{'}
                    <br />  "work_no": 172966702,
                    <br />  "job_name": "상품등록",
                    <br />  "status": "완료",
                    <br />  "message": [
                    <br />    "[성공] : m2024051034984a215 / 3789117229"
                    <br />  ],
                    <br />  "product_info": [
                    <br />    {'{'}
                    <br />      "c_sale_cd": "m2024051034984a215",
                    <br />      "ol_shop_no": 336487,
                    <br />      "shop_sale_no": "3789117229",
                    <br />      "status": "성공",
                    <br />      "msg": "m2024051034984a215 / 3789117229"
                    <br />    {'}'}
                    <br />  ]
                    <br />{'}'}
                    <br />
                    <br />---- 상품작업 결과 (실패시) ----
                    <br />{'{'}
                    <br />  "work_no": 172966702,
                    <br />  "job_name": "판매중지",
                    <br />  "status": "실패",
                    <br />  "message": [
                    <br />    "[실패] : m20220914f60d00d1b, ESM어드민에 [9999999999]상품이 존재하지 않습니다. ESM어드민 접속 하시어 상품을 확인해 주시기 바랍니다.",
                    <br />    "[실패] : m20220927a547a62c6, ESM어드민 상에서 [[888888888]]상품이 조회되지 않습니다. ESM 어드민으로 접속 하시어 상품을 확인해 주시기 바랍니다."
                    <br />  ],
                    <br />  "product_info": [
                    <br />      {'{'}
                    <br />        "c_sale_cd": "판매자관리코드",
                    <br />        "ol_shop_no": "쇼핑몰상품 고유번호",
                    <br />        "shop_sale_no": "쇼핑몰 상품코드",
                    <br />        "status": "실패",
                    <br />        "msg": "m20220914f60d00d1b, ESM어드민에 [9999999999]상품이 존재하지 않습니다. ESM어드민 접속 하시어 상품을 확인해 주시기 바랍니다."
                    <br />      {'}'},
                    <br />      {'{'}
                    <br />        "c_sale_cd": "m20220927a547a62c6",
                    <br />        "ol_shop_no": 6633445,
                    <br />        "shop_sale_no": "888888888",
                    <br />        "status": "실패",
                    <br />        "msg": "m20220927a547a62c6, ESM어드민 상에서 [[888888888]]상품이 조회되지 않습니다. ESM 어드민으로 접속 하시어 상품을 확인해 주시기 바랍니다."
                    <br />      {'}'}
                    <br />    ]
                    <br />  {'}'}
                    <br />
                    <br />---- 상품 외 작업 결과 (성공시) ----
                    { [1051].includes(userInfo.aff_no) ? 
                    <>
                      <br />[{'{'}
                      <br />  com: 'PLAYAUTO',
                      <br />  encver: '2.0',
                      <br />  encYn: 'N',
                      <br />  msg: '{'{'}"body":{'{'}"work_no":172279187,"job_name":"주문수집","status":"완료","message":"[성공] : 변경사항이 없습니다"{'}'},"header":'{'{'}"bizPtrId":"PLAYAUTO","callId":"playauto0001","ifCd":"PLAYAUTO","encType":"UTF-8","token":"PLAYAUTO[13.125.30.102]FTGsfgr5ht4HhfrDbBFW6j==20230010100001"{'}}'}'
                      <br />{'}'}]
                    </>
                    : 
                    <>
                      <br />{'{'}
                      <br />  "work_no": 172279187,
                      <br />  "job_name": "주문수집",
                      <br />  "status": "완료",
                      <br />  "message": [
                      <br />    "[성공] : 2건 성공 / 0건 실패 "
                      <br />  ]
                      <br />{'}'}
                    </>}
                    <br />
                    <br />---- 상품 외 작업 결과 (실패시) ----
                    <br />{'{'}
                    <br />  "work_no": 172279187,
                    <br />  "job_name": "주문수집",
                    <br />  "status": "실패",
                    <br />  "message": [
                    <br />    "[성공] : wpartner.wemakeprice.com 주문 수집 종료"
                    <br />  ]
                    <br />{'}'}
                  </pre>
              </li>
            </ul>
          ),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'work_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '작업액션', allowedValues: [
                  'SEND_INVOICE', 'SEND_CS', 'CONFIRM_ORDER', 'DELAYED_ORDER_PAYMENT',
                  'DELAYED_ORDER', 'UPDATE_HOPE_DATE',
                  ...([1, 1957, 5422, 77327, 129725, 121024, 122081, 122082].includes(userInfo?.m_no) || userInfo.aff_no === 1051 ? ['PRINT_SLS_LABEL'] : []),
                  'REGIST_PROD', 'EDIT_PROD_ALL', 'EDIT_PROD', 'STOP_PROD',
                  'RESTORE_PROD', 'REGIST_PROD_RE', 'REGIST_PROD_NEW',
                  'SYNC_PROD_STATE', 'EXTENT_PROD', 'CANCEL_PROD',
                  ...(isClaimCstm ? ['APPROVE_CLAIM', 'REJECT_CLAIM', 'COLLECT_CLAIM', 'COMPLETE_CLAIM', 'DEFER_CLAIM'] : [])
                ] }),
            },
            {
              title: 'exclude_yn',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '대상상품이 아닌경우 제외하고 작업을 진행할지의 여부', sub: '(온라인상품 수정 작업에만 적용됩니다.)',
                defaultValue: 'N',
                allowedValues: ['Y', 'N'] }),
            },
            {
              title: 'list',
              required: '',
              type: 'String[]',
              desc: apiParamDesc({ title: '상품 또는 주문 또는 문의의 고유번호', sub: [
                  '<code>송장전송 작업이 아닌경우 필수입니다.</code>',
                  '송장전송 작업 시 해당 필드가 없으면 출고완료 주문 전체가 송장전송됩니다.'
                ],
                notes: ['주문: uniq 또는 bundle_no', '문의: inq_uniq', '상품: ol_shop_no'] }),
            },
            {
              title: 'edit_col',
              required: '',
              type: 'Object',
              desc: apiParamDesc({ title: '부분수정할 항목', sub: [
                  '쇼핑몰상품 부분수정 작업시 필수입니다.',
                  '수정하지 않을 항목은 입력하지 않아도 됩니다.'
                ] }),
            },
            {
              title: 'isEditName',
              required: '',
              type: 'Boolean',
              desc: '상품명',
              indent: 1,
            },
            {
              title: 'isEditPrice',
              required: '',
              type: 'Boolean',
              desc: '판매가',
              indent: 1,
            },
            {
              title: 'isEditOpt',
              required: '',
              type: 'Boolean',
              desc: '옵션',
              indent: 1,
            },
            {
              title: 'isEditAddopt',
              required: '',
              type: 'Boolean',
              desc: '추가구매옵션',
              indent: 1,
            },
            {
              title: 'isEditContent',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({ title: '상세설명', sub: '(머리말/꼬리말 포함)' }),
              indent: 1,
            },
            {
              title: 'isEditImage',
              required: '',
              type: 'Boolean',
              desc: '이미지',
              indent: 1,
            },
            {
              title: 'sync_col',
              required: '',
              type: 'Object',
              desc: apiParamDesc({ title: '상품동기화할 항목', sub: [
                  '쇼핑몰상품 동기화 작업시 필수입니다.',
                  '수정하지 않을 항목은 입력하지 않아도 됩니다.'
                ] }),
            },
            {
              title: 'status',
              required: '',
              type: 'Boolean',
              desc: '상품상태',
              indent: 1,
            },
            {
              title: 'count',
              required: '',
              type: 'Boolean',
              desc: '판매수량',
              indent: 1,
            },
            {
              title: 'period',
              required: '',
              type: 'Boolean',
              desc: '상품 판매 종료일',
              indent: 1,
            },
            {
              title: 'price',
              required: '',
              type: 'Boolean',
              desc: '판매가격',
              indent: 1,
            },
            {
              title: 'extension_date',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '판매기간연장일', sub: '쇼핑몰상품 판매기간연장 작업시 필수입니다.',
                allowedValues: ['15', '30', '60', '90'] }),
            },
            {
              title: 'delay_reason',
              required: '',
              type: 'String',
              desc: '배송지연 사유',
            },
            {
              title: 'delay_date',
              required: '',
              type: 'String',
              desc: '배송지연 날짜',
            },
            {
              title: 'delay_code',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '희망배송일 변경 코드', sub: '희망배송일 변경 작업시 필수입니다.',
                allowedValues: [
                  ['DATE_CHANGED_BY_BUYER', '구매자 요청으로 인한 날짜 변경'],
                  ['INVALID_ADDRESS', '고객부재/배송정보 오류'],
                  ['CAPACITY_EXCEEDED', '배송 물량 초과'],
                  ['LOGISTICS_ISSUE', '물류사/배송사 이슈'],
                  ['SOLD_OUT', '상품 불량 및 재고 부족'],
                  ['DELAYED', '판매자 출고 지연'],
                  ['INSTALLATION_ISSUE', '상품 설치 작업 중 이슈'],
                  ['NATURAL_DISASTER', '천재지변']
                ] }),
            },
            ...(userInfo?.sol_no === 26164 ? [{
              title: 'sub_sol_no',
              required: 'O',
              type: 'Number',
              desc: '하위 계정 sol_no',
            }] : []),
            {
              title: 'show_shop_info_yn',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({ title: '등록 작업 쇼핑몰정보 노출여부', sub: '콜백URL 결과 데이터 응답 시 사용됩니다.',
                defaultValue: 'false',
                allowedValues: ['true', 'false'] })
            },
            {
              title: 'dupl_doubt_except_yn',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '중복의심주문 제외 여부', sub: '(\'Y\': 제외 후 작업, \'N\': 제외하지 않고 작업)',
                defaultValue: 'N' }),
            },
            {
              title: 'api_callback_url',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '작업완료시 작업결과를 수신받을 URL', sub: '해당정보 입력시 작업결과를 입력하신 주소로 POST 방식으로 전송합니다.' }),
            },
            ...(isClaimCstm ? 
            [
              {
                title: 'claim_type',
                required: '',
                type: 'String',
                desc: apiParamDesc({ title: '클레임 유형', sub: '클레임 작업 시 필수입니다.',
                  allowedValues: [
                    ['CANCELLATION', '취소'],
                    ['RETURN', '반품'],
                    ['EXCHANGE', '교환']
                  ] }),
              },
              {
                title: 'claim_reason_code',
                required: '',
                type: 'String',
                desc: apiParamDesc({ title: '클레임 사유 코드', sub: [
                    '클레임 거절 및 보류 작업에 한하여 사용됩니다.',
                    '작업별로 사유 코드 및 구분 메세지가 다르니, 본문 설명을 참고해주세요.'
                  ] })
              },
              {
                title: 'claim_reason_message',
                required: '',
                type: 'String',
                desc: apiParamDesc({ title: '클레임 상세 사유', sub: [
                    '클레임 거절 및 보류 작업에 한하여 사용됩니다.',
                    '<code>claim_reason_code</code>를 입력하고 <code>claim_reason_message</code>를 비워둘 경우,',
                    '<code>claim_reason_code</code>에 해당하는 기본 메세지로 전송됩니다.'
                  ] })
              },
              {
                title: 'claim_carr_no',
                required: '',
                type: 'String',
                desc: apiParamDesc({ title: '운송장 택배사 코드', sub: [
                    '운송장 정보가 요구되는 일부 클레임 작업에 한하여 사용됩니다.(본문 설명 참고)',
                    '공통 API로 택배사 코드를 조회할 수 있습니다.',
                    '(API 문서 &gt; 공통 &gt; 택배사 코드 조회)'
                  ] })
              },
              {
                title: 'claim_invoice_no',
                required: '',
                type: 'String',
                desc: apiParamDesc({ title: '클레임 운송장 번호', sub: '운송장 정보가 요구되는 일부 클레임 작업에 한하여 사용됩니다.(본문 설명 참고)' })
              }
            ] : []),
          ],
          body_example: [
            '# 운송장정보 쇼핑몰 전송',
            {
              work_type: 'SEND_INVOICE',
              list: [
                '3782381925823309795',
                '3782381925823309796',
                '3782381925823309797',
              ],
              api_callback_url: 'https://test.io/callback',
            },
            '# 쇼핑몰상품 등록 전송',
            {
              work_type: 'REGIST_PROD',
              list: [
                '1111111', '2222222', '3333333'
              ],
              api_callback_url: 'https://test.io/callback',
            },
            '# 쇼핑몰상품 부분수정 전송',
            {
              work_type: 'EDIT_PROD',
              list: [
                '1111111', '2222222', '3333333'
              ],
              edit_col: {
                isEditName: false,
                isEditPrice: false,
                isEditOpt: true,
                isEditContent: false,
                isEditImage: false,
              },
              api_callback_url: 'https://test.io/callback',
            },
            '# 쇼핑몰상품 수정 전송',
            {
              work_type: 'EDIT_PROD_ALL',
              list: [
                '1111111', '2222222', '3333333'
              ],
              api_callback_url: 'https://test.io/callback',
            },
            '# 쇼핑몰상품 품절전송',
            {
              work_type: 'STOP_PROD',
              list: [
                '1111111', '2222222', '3333333'
              ],
              api_callback_url: 'https://test.io/callback',
            },
            '# 쇼핑몰상품 품절복구 전송',
            {
              work_type: 'REGIST_PROD_RE',
              list: [
                '1111111', '2222222', '3333333'
              ],
              api_callback_url: 'https://test.io/callback',
            },
            '# 쇼핑몰상품 동기화',
            {
              work_type: 'SYNC_PROD_STATE',
              list: [
                '1111111', '2222222', '3333333'
              ],
              sync_col: {
                status: true,
                count: true,
                period: true,
                price: true,
              },
              api_callback_url: 'https://test.io/callback',
            },
            '# 쇼핑몰상품 판매기간 연장',
            {
              work_type: 'EXTENT_PROD',
              list: [
                '1111111', '2222222', '3333333'
              ],
              extension_date: 15,
              api_callback_url: 'https://test.io/callback',
            },
            '# 쇼핑몰상품 판매중지',
            {
              work_type: 'CANCEL_PROD',
              list: [
                '1111111', '2222222', '3333333'
              ],
              api_callback_url: 'https://test.io/callback',
            },
          ],
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Array',
              desc: '결과\n(실패시 error 로 출력)',
            },
            {
              title: 'work_no',
              required: 'O',
              type: 'Number',
              desc: '등록된 작업번호',
              indent: 1,
            },
            {
              title: 'error_code',
              required: '',
              type: 'String',
              desc: '실패시 출력되는 에러코드',
              indent: 1,
            },
            {
              title: 'message',
              required: 'O',
              type: 'String',
              desc: '성공, 실패 메세지',
              indent: 1,
            },
            {
              title: 'list',
              required: '',
              type: 'String[]',
              desc: '등록한 list 정보\n(성공인경우 출력)\n(주문작업인 경우 list 에 uniq 값을 넣었어도 묶음번호 데이터로 출력)',
              indent: 1,
            }
          ],
          response_example: {
            "results": [
                {
                    "work_no": 487772398,
                    "message": "작업이 정상적으로 등록되었습니다.",
                    "list": [
                        "3938009934902534",
                        "3938713558156561"
                    ]
                }
            ]
        },
          error_example: {
            "error": [
                {
                    "work_no": 0,
                    "error_code": "e6999",
                    "messages": [
                        "작업등록에 실패하였습니다."
                    ]
                }
            ]
        }
        },
      ],
    },
    {
      title: '작업 삭제',
      url: '/doc/작업 삭제',
      data: [
        {
          version: 'v1.1',
          url: '/work/delete/v1.1',
          method: 'DELETE',
          desc: (
            <ul className='style'>
              <li>등록된 작업을 삭제합니다.</li>
              <li>대기,완료,실패,오류 상태의 작업만 삭제됩니다.</li>
            </ul>
          ),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'work_nos',
              required: 'O',
              type: 'Number[]',
              desc: '작업번호',
            },
            {
              title: 'is_all',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '전체 작업 삭제 여부', defaultValue: 'N',
                allowedValues: ['Y', 'N'] }),
            },
          ],
          body_example: {
            '- 선택 작업만 삭제하는 경우': {
              work_nos: [181044917, 181167926],
              is_all: 'N',
            },
            '- 전체 작업을 삭제하는 경우': {
              work_nos: [],
              is_all: 'Y',
            },
          },
          response: [
            {
              title: 'message',
              required: 'O',
              type: 'String',
              desc: '결과 메세지',
            },
            {
              title: 'delete_cnt',
              required: 'O',
              type: 'Number',
              desc: '삭제된 작업 개수',
            },
          ],
          response_example: {
            message: '작업이 정상적으로 삭제되었습니다.',
            delete_cnt: 2,
          },
        },
      ],
    },
  ];
};

export default getV11APIs;
